<ion-app id="app1" dir="{{ textDir }}">
  <!-- when=false means that the split pane will never expand automatically -->
  <!-- For more info check https://ionicframework.com/docs/api/split-pane -->
  <ion-split-pane contentId="menu-content" [when]="displaySidePane$ | async">
    <ion-menu menuId="main-menu" contentId="menu-content" class="app-sidemenu">
      <ion-header>
        <ion-toolbar>
          <ion-row class="user-details-wrapper">
                        <ion-col class="user-info-wrapper" size="11">
              <div id="app2" class="user-name">RecoveryTrac Flex v{{ appVersion }}</div>
            </ion-col>
            <ion-col size="1">
              <ion-menu-toggle>
                <span class="side-menu-close-icon"><ion-icon size="large" name="close-outline"></ion-icon></span>
              </ion-menu-toggle>
            </ion-col>
          </ion-row>
        </ion-toolbar>
      </ion-header>

      <ion-content>
        <ion-list>
          <ion-menu-toggle autoHide="false" *ngFor="let p of appPages; let i = index">
            <ion-item *ngIf="!p.hidden" [routerLink]="p.url" detail="false">
              <ion-icon slot="start" [name]="p.ionicIcon"> </ion-icon>
              <ion-label id="app3">
                {{ p.title }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list style="border-top: 1px solid #a6a6a6">
          <ion-menu-toggle autoHide="false" *ngFor="let p of appInfoPages; let i = index">
            <ion-item *ngIf="!p.hidden" [routerLink]="p.url" detail="false">
              <ion-label id="app4">
                {{ p.title }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>

        <ion-list style="border-top: 1px solid #a6a6a6">
          <ion-item style="cursor: pointer" detail="false">
            <ion-icon slot="start" class="logout"></ion-icon>
            <ion-label id="app5" (click)="logout()" class="logout_txt">Log Out</ion-label>
          </ion-item>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="menu-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
